export default "__VITE_ASSET__DpjAeBZu__"